var React = require('react');

function Sms (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13 0C14.1046 0 15 0.89543 15 2V16C15 17.1046 14.1046 18 13 18H5C3.89543 18 3 17.1046 3 16V2C3 0.89543 3.89543 0 5 0H13ZM9 15C8.44772 15 8 15.4477 8 16C8 16.5523 8.44772 17 9 17C9.55228 17 10 16.5523 10 16C10 15.4477 9.55228 15 9 15ZM5 2H13V14H5V2Z","fill":"#424242"}));
}

Sms.defaultProps = {"width":"20","height":"20","viewBox":"0 0 18 18","fill":"none"};

module.exports = Sms;

Sms.default = Sms;
